import { render, staticRenderFns } from "./InboxLogTypeDetail.vue?vue&type=template&id=68f06afc"
import script from "./InboxLogTypeDetail.vue?vue&type=script&lang=ts"
export * from "./InboxLogTypeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports